import { CSRFToken, Token } from './token.js';

export class TokenStorage<T extends Token|CSRFToken> {
    constructor(private identifier: string, private token: T = null) {
        if (!identifier) {
            throw new Error('TokenStorage requires an identifier');
        }

        if (token !== null) {
            this.setToken(token);
        }
    }

    /**
     * save token to localStorage
     * @param token
     */
    public setToken(token: T) {
        TokenStorage.checkToken(token);
        window.localStorage.setItem(this.identifier, JSON.stringify(token));
    }

    /**
     * get token from localStorage
     */
    public getToken(): T|null {
        try {
            this.token = JSON.parse(window.localStorage.getItem(this.identifier));
            TokenStorage.checkToken(this.token);
        } catch (e) {
            console.error('Invalid token in localStorage');
            return null;
        }

        return this.token;
    }

    public static checkToken(token: Token|CSRFToken|any): void {
        if (token instanceof Token && Token.valid(token) === false) {
            token = null;
            throw new Error('invalid token');
        } else if (token instanceof CSRFToken && CSRFToken.valid(token) === false) {
            token = null;
            throw new Error('invalid csrf token');
        }
    }

    public purge(): void {
        window.localStorage.removeItem(this.identifier);
    }
}
